import { jsx as _jsx } from "preact/jsx-runtime";
// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from pointer-down.svg
 */
export default function PointerDownIcon(props) {
  return _jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "9",
    "data-component": "PointerDownIcon",
    ...props,
    children: _jsx("path", {
      stroke: "currentColor",
      d: "m15.5 0-7 8-8-8"
    })
  });
}
//# sourceMappingURL=PointerDown.js.map